import { Modal, toast } from '@pmi/dsm-react';
import { useState } from 'react';
import styles from './unErrollProductModal.module.scss';
import { User } from '../../../../../../shared/models/UserModels';
import { ProductApiModel } from '../../../../../../shared/models/ProductModel';
import { useRemoveEnrolledProductMutation } from './apiSlice';
import useUser from '../../../../../../shared/hooks/useUser';
import RenderHtml from '../../../../../../shared/components/RenderHtml';

export interface RemoveProductModalProps {
  onCancel: () => void;
  user: User;
  product: ProductApiModel;
  agreementId: string;
  userProductId: number;
}

export default function RemoveProductModal({
  onCancel,
  user,
  agreementId,
  product,
  userProductId,
}: RemoveProductModalProps) {
  const currentUser = useUser();
  const [remove, removed] = useRemoveEnrolledProductMutation();
  const [submitting, setSubmitting] = useState(false);
  const onRemove = () => {
    setSubmitting(true);
    remove({
      userId: Number(user.id),
      modifiedByUser: {
        id: Number(currentUser.person_id),
        name: `${currentUser.given_name} ${currentUser.family_name}`,
      },
      accountProductId: Number(userProductId),
      agreementId,
    })
      .unwrap()
      .then(() => {
        toast(
          <span className="fw-normal">
            You have removed <RenderHtml html={product.name} tag="span" /> from{' '}
            {agreementId}
          </span>,
          'success',
        );
        onCancel();
      })
      .catch(() => {
        toast(
          <span className="fw-normal">
            Failed to removed <RenderHtml html={product.name} tag="span" /> from{' '}
            {agreementId}
          </span>,
          'danger',
        );
      })
      .finally(() => {
        removed.reset();
        setSubmitting(false);
      });
  };
  return (
    <Modal
      show
      backdrop="static"
      onClose={() => {
        if (removed.isLoading) {
          return;
        }
        onCancel();
      }}
      title=""
      variant="dialog"
      buttons={[
        {
          titleText: 'Close',
          variant: 'outline-secondary',
          onClick: onCancel,
          size: 'sm',
          disabled: removed.isLoading || submitting,
        },
        {
          titleText: 'Remove Product',
          variant: 'primary',
          onClick: onRemove,
          size: 'sm',
          disabled: removed.isLoading || submitting,
        },
      ]}
      customClassName={styles.unEnrollModalBody}
    >
      <div className={`${styles.unEnrollContents} py-4`}>
        <h5 className="mb-3">
          Are you sure you want to remove{' '}
          <RenderHtml html={product.name} tag="span" /> from{' '}
          {user.personName || user.email}?
        </h5>
        <p>
          This action will revoke their access to{' '}
          <RenderHtml html={product.name} tag="span" />. You can reassign it
          later if needed.
        </p>
      </div>
    </Modal>
  );
}
